import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import LoginButton from '../LoginPage/LoginButton';

const StyledLoginContainer = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const StyledLoginButton = css`
  margin-top: 1rem;
  width: 100%;
`;

const LoginOut = () => {
  return (
    <StyledLoginContainer>
      <div>
        <span>Thank you for using Healthcare Directory</span>
        <br />
        <span>You have successfully logged out</span>
        <LoginButton props={StyledLoginButton} />
      </div>
    </StyledLoginContainer>
  );
};

export default LoginOut;
